import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SalesCreditTermsContainerModel } from "../../../../../../models/aggregates/erp/credit";
import { Core2Config } from "../../shared/core2Config";
import { ApiResponseModel, ApiVisa } from "../../shared";
import { Observable } from "rxjs";
import { BaseApiPublicLoginTemplateService } from "../../shared/base-api-public-login-template.service";

@Injectable({ providedIn: "root" })
export class SalesCreditTermsService extends BaseApiPublicLoginTemplateService<SalesCreditTermsContainerModel, SalesCreditTermsContainerModel, SalesCreditTermsContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "fi/entity-sales-credit-terms/backoffice-ep";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "fi/entity-sales-credit-terms/backoffice-ep";
    this.endpoint_path_login_url =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "fi/entity-sales-credit-terms/login-ep";
    this.httpClient = http;
  }

  postMultiEntitySalesCreditTerms(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = this.apiUrl + "/add-multi-credit-terms";
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      customUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }
}
